import Settings from "./Settings";
import { AuthToken } from "./AuthToken";

import ProcessingResult from "../framework/ProcessingResult";

import { UserRolesHelper } from "../logics/usermodule/UserRolesHelper";

import RoleGroupDto from "../classes/dtos/rolegroupmodule/RoleGroupDto";

export enum RoleGroupFilterMode {
    All = 0,
    Workspace = 1,
    WithoutWorkspace = 2
}

const RoleGroupApi = {

    GetRoleGroupAsync: async function (filterMode: RoleGroupFilterMode): Promise<ProcessingResult<RoleGroupDto[]>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/RoleGroup/GetRoleGroups?filterMode=" + filterMode, {
            method: "Get",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(data.roleGroups.map((e: { id: number; name: string; role: number; userIds: number[] }) => new RoleGroupDto(e.id, e.name || UserRolesHelper.getRoleNameById(e.role), e.role, e.userIds)));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    CreateRoleGroupAsync: async function (name: string, role: number, userIds: number[]): Promise<ProcessingResult<number>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/RoleGroup/CreateRoleGroup", {
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            },
            body: JSON.stringify({
                'name': name,
                'role': role,
                'userIds': userIds
            })
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(data.id);
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    UpdateRoleGroupAsync: async function (id: number, name: string, role: number, userIds: number[]): Promise<ProcessingResult<boolean>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/RoleGroup/UpdateRoleGroup", {
            method: "PUT",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            },
            body: JSON.stringify({
                'id': id,
                'name': name,
                'role': role,
                'userIds': userIds
            })
        });

        if (response.status === 200) {
            return ProcessingResult.Ok(true);
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    DeleteRoleGroupAsync: async function (id: number): Promise<ProcessingResult<boolean>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/RoleGroup/DeleteRoleGroup?id=" + id, {
            method: "DELETE",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            return ProcessingResult.Ok(true);
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },
};

export default RoleGroupApi;